import React from 'react'
export const StorageMediaContext = React.createContext({ state: {} });

